import IService from '../IService';

/**
 * @namespace app.api.themeInfo
 */
export default IService.extend({
  get: function ({ programmerId, brandId }) {
    const deferred = new $.Deferred();

    this.$ajax = $.ajax({
      url: app.apiUrl('/api/v1/theme/info'),
      type: 'GET',

      data: {
        programmerId,
        brandId,
      },

      error: function (jqXHR, textStatus, errorThrown) {
        if (textStatus === 'abort') {
          console.trace('Theme request aborted by user');
        } else {
          app.doctorController.report(
            'Server error in themeInfo.js ' + textStatus
          );
          deferred.reject(textStatus, errorThrown);
        }
      },

      dataType: 'json',
      success: function (response) {
        if (!_.isEmpty(response) && _.isObject(response)) {
          deferred.resolve(response);
        } else {
          app.doctorController.report('Invalid response in themeInfo.js');
          deferred.reject(response);
        }
      },
    }).always(() => {
      this.$ajax = null;
    });

    return deferred.promise();
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
    return this;
  },
});
